module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai54-72f9b3a96ba1b94e9650f55fbe524f65.jpg";